var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-lg d-flex flex-column justify-center ma-0 pa-0 imageEmptyStateStyle blue-grey lighten-3",staticStyle:{"width":"112px","height":"112px"}},[_c('v-icon',{attrs:{"size":"40","color":"blue-grey"}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }